<template>
  <FormInput v-model="modelValue" :name type="number" :placeholder="$t('LoginOrReg.PhoneTips')" autocomplete="off" autocapitalize="off"
    :formatter="formatPhoneNumber" :rules="[
      {
        validator: validatePhoneNumber,
        message: $t('LoginOrReg.PhoneErrorTips'),
        trigger: 'onChange',
      },
    ]">
    <template #left-icon>
      <div class="flex items-center text-white font-[600] text-15 mr-2.5">
        <Image :src="nationFlag" class="w-6 h-[17px] mr-[5px]" />
        {{ nationCode }}
      </div>
    </template>

    <template #errorTip="{ message }">
      <div class="py-2 text-11 text-[var(--theme-primary-error)] flex pl-4 leading-16">
        <img class="mr-2 mt-[2px] size-3" src="@a/assets/images/i_err.png" />
        {{ message }}
      </div>
    </template>

    <template #extraTip v-if="!noTip">
      <div class="bg-[var(--input-tip-bg-color)] text-[#FFFFFF80] rounded-[8px] flex py-2 px-4 mt-2">
        <img class="size-[18px] mr-2" src="@a/assets/images/i_important.png" alt="Tip" />
        <span class="text-11">
          {{ $t('LoginOrReg.PhoneNumberDescription') }}
        </span>
      </div>
    </template>
  </FormInput>
</template>

<script setup lang="ts">
  import FormInput from '@a/components/FormInput';
  // import { validatePhoneNumber } from '@/utils/validate'
  import config from '@/config'
  const { nationFlag, nationCode } = config || {}
  
  const validatePhoneNumber = (value: string) => {
    return value.trim().length === 11
  }

  withDefaults(
    defineProps<{
      // placeholder?: string
      // errorMsg?: string
      noTip?: boolean
      name?: string
    }>(),
    {
      // placeholder: 'Número de telefone',
      // errorMsg: 'Por favor, insira um número de telefone com 11 dígitos.',
      noTip: false,
      name: 'phone',
    },
  )

  const modelValue = defineModel<string>()

  const formatPhoneNumber = (value: string) => {
    return value.replace(/\s/g, '');
  }
</script>
